document.addEventListener("DOMContentLoaded", function () {
  const sliderContainer = document.querySelector(
    ".mobile-nav-banner-slider__container"
  );
  if (!sliderContainer) return;

  let isDown = false;
  let startX;
  let scrollLeft;

  // Mouse events
  sliderContainer.addEventListener("mousedown", function (e) {
    isDown = true;
    sliderContainer.style.cursor = "grabbing";
    startX = e.pageX - sliderContainer.offsetLeft;
    scrollLeft = sliderContainer.scrollLeft;
  });

  sliderContainer.addEventListener("mouseleave", function () {
    isDown = false;
    sliderContainer.style.cursor = "grab";
  });

  sliderContainer.addEventListener("mouseup", function () {
    isDown = false;
    sliderContainer.style.cursor = "grab";
  });

  sliderContainer.addEventListener("mousemove", function (e) {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - sliderContainer.offsetLeft;
    const walk = (x - startX) * 2;
    sliderContainer.scrollLeft = scrollLeft - walk;
  });

  // Touch events
  sliderContainer.addEventListener("touchstart", function (e) {
    startX = e.touches[0].pageX - sliderContainer.offsetLeft;
    scrollLeft = sliderContainer.scrollLeft;
  });

  sliderContainer.addEventListener("touchmove", function (e) {
    if (!startX) return;
    e.preventDefault();
    const x = e.touches[0].pageX - sliderContainer.offsetLeft;
    const walk = (x - startX) * 2;
    sliderContainer.scrollLeft = scrollLeft - walk;
  });

  sliderContainer.addEventListener("touchend", function () {
    startX = null;
  });

  // Set initial cursor
  sliderContainer.style.cursor = "grab";
});
